





















































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { IInventoryAdvancePayment, IUser } from '@/models';
import EmployeeUserPicker from '../employee/EmployeeUserPicker.vue';

export default Vue.extend({
  name: 'InventoryAdvancePaymentOwnerListMenu',

  components: { EmployeeUserPicker },

  props: {
    inventoryAdvancePayment: {
      type: Object as () => IInventoryAdvancePayment,
      required: true
    },
    disabled: Boolean
  },

  data() {
    return {
      ownerLoading: false,
      ownerDialog: false,
      errorMessage: '',
      owner: null as null | number
    };
  },

  watch: {
    ownerDialog(value: boolean) {
      if (value) {
        if (this.inventoryAdvancePayment.owner) {
          this.owner =
            (this.inventoryAdvancePayment.owner as IUser).id ??
            (this.inventoryAdvancePayment.owner as number);
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateInventoryAdvancePaymentOwner:
        'inventoryAdvancePayment/updateInventoryAdvancePaymentOwner'
    }),

    closeDialog() {
      this.errorMessage = '';
      this.ownerLoading = false;
      this.ownerDialog = false;
    },

    async setInventoryAdvancePaymentOwner(owner: number) {
      this.ownerLoading = true;
      await this.updateInventoryAdvancePaymentOwner({
        inventoryAdvancePaymentId: this.inventoryAdvancePayment.id,
        owner
      })
        .then(() => {
          this.closeDialog();
        })
        .catch(() => {
          this.errorMessage = 'Error assigning owner';
          this.ownerLoading = false;
        });
    }
  }
});
